import { createSlice } from '@reduxjs/toolkit';

import { wepodPayOrder } from 'Feature/Orders/Common/Actions/Thunks/wepodPayOrder';
import { PageSizing } from 'Shared/Core/Common/Options/PageSizing';

import StepOneModelInitialState from '../Components/01-StepOne/Models/StepOneModelInitialState';

import {
  createLoan,
  createPremiumInstallment,
  getActiveLoan,
  getAllLoanPaidPagedFilter,
  getAllLoanUnPaidPagedFilter,
  getAllPremiumInstallmentPaidPagedFilter,
  getAllPremiumInstallmentUnPaidPagedFilter,
  getInsurancePolicyInfoDetail,
  getPayPremiumInstallmentConfig,
} from './action';
import { ILifeInformationAndPayState } from './model';

const initialState: ILifeInformationAndPayState = {
  stepOneData: null,
  stepTwoData: null,
  payPremiumInstallmentConfig: {
    loading: false,
    data: {
      maximumOverdueAllowToPay: 0,
      payTypeCodeOptions: [],
    },
  },
  insurancePolicyInfoDetail: {
    data: null,
    loading: false,
  },
  insurancePolicyInfo: null,
  premiumInstallment: {
    loading: false,
  },
  loan: {
    loading: false,
  },
  payOrder: {
    loading: false,
  },
  premiumInstallmentsPaid: {
    loading: false,
    data: {
      pageNumber: 0,
      pageSize: PageSizing[1].value as number,
      totalCount: 0,
      queryResult: null,
    },
    queryParams: {
      pageNumber: 1,
      pageSize: 12,
      needTotalCount: true,
      sortAscending: false,
      sortBy: null,
    },
    pagination: {
      currentPage: 1,
      tableColumn: 0,
      totalPage: 0,
      customPageSize: PageSizing[1].value as number,
      firstItemNumber: 0,
      lastItemNumber: 0,
    },
  },

  premiumInstallmentsUnPaid: {
    loading: false,
    data: {
      pageNumber: 0,
      pageSize: PageSizing[1].value as number,
      totalCount: 0,
      queryResult: null,
    },
    queryParams: {
      pageNumber: 1,
      pageSize: 12,
      needTotalCount: true,
      sortAscending: false,
      sortBy: null,
    },
    pagination: {
      currentPage: 1,
      tableColumn: 0,
      totalPage: 0,
      customPageSize: PageSizing[1].value as number,
      firstItemNumber: 0,
      lastItemNumber: 0,
    },
  },
  activeLoan: {
    data: null,
    loading: false,
  },
  loansPaid: {
    loading: false,
    data: {
      pageNumber: 0,
      pageSize: PageSizing[1].value as number,
      totalCount: 0,
      queryResult: null,
    },
    queryParams: {
      pageNumber: 1,
      pageSize: 12,
      needTotalCount: true,
      sortAscending: false,
      sortBy: null,
    },
    pagination: {
      currentPage: 1,
      tableColumn: 0,
      totalPage: 0,
      customPageSize: PageSizing[1].value as number,
      firstItemNumber: 0,
      lastItemNumber: 0,
    },
  },

  loansUnPaid: {
    loading: false,
    data: {
      pageNumber: 0,
      pageSize: PageSizing[1].value as number,
      totalCount: 0,
      queryResult: null,
    },
    queryParams: {
      pageNumber: 1,
      pageSize: 12,
      needTotalCount: true,
      sortAscending: false,
      sortBy: null,
    },
    pagination: {
      currentPage: 1,
      tableColumn: 0,
      totalPage: 0,
      customPageSize: PageSizing[1].value as number,
      firstItemNumber: 0,
      lastItemNumber: 0,
    },
  },

  wizard: {
    begin: 1,
    end: 7,
    current: 1,
  },
};

export const lifeInformationAndPayReducer = createSlice({
  name: 'LifeInsu/InformationAndPay',
  initialState: initialState,
  reducers: {
    setInformationAndPayBimehNamehInitialState: (state) => {
      state.stepOneData = StepOneModelInitialState;
      state.wizard = initialState.wizard;
    },
    setInsurancePolicyInfo: (state, action) => {
      state.insurancePolicyInfo = action.payload;
    },

    setStepOneModel: (state, action) => {
      state.stepOneData = action.payload;
    },
    setStepTwoModel: (state, action) => {
      state.stepTwoData = action.payload;
    },
    clearStepOneModel: (state) => {
      state.stepOneData = StepOneModelInitialState;
    },

    resetWizard: (state) => {
      state.wizard = initialState.wizard;
    },
    informationAndPayBimehNamehHaStep: (state) => {
      state.wizard.current = 2;
    },
    informationAndPayDetailWizard: (state) => {
      state.wizard.current = 3;
    },
    informationAndPayWizardPremiumInstallmentsPaidStep: (state) => {
      state.wizard.current = 4;
    },
    informationAndPayWizardPremiumInstallmentsUnPaidStep: (state) => {
      state.wizard.current = 5;
    },
    informationAndPayWizardLoansPaidStep: (state) => {
      state.wizard.current = 6;
    },
    informationAndPayWizardLoansUnPaidStep: (state) => {
      state.wizard.current = 7;
    },
    informationAndPayWizardPayInstallmentStep: (state) => {
      state.wizard.current = 8;
    },
    informationAndPayWizardNextStep: (state) => {
      let nextStep = 0;
      nextStep = state.wizard.current + 1;
      if (nextStep <= state.wizard.end) {
        state.wizard.current = nextStep;
      }
    },

    informationAndPayWizardPreviousStep: (state) => {
      let previousStep = 0;
      previousStep = state.wizard.current - 1;
      if (previousStep >= state.wizard.begin) {
        state.wizard.current = previousStep;
      }
    },
    setTotalPagePremiumInstallmentsPaid: (state, action) => {
      state.premiumInstallmentsPaid.pagination.totalPage = action.payload;
    },
    clearPremiumInstallmentsPaid: (state) => {
      state.premiumInstallmentsPaid.data = undefined;
    },
    clearPremiumInstallmentsPaidQuery: (state) => {
      state.premiumInstallmentsPaid.queryParams = initialState.premiumInstallmentsPaid.queryParams;
    },
    clearLoansPaidQuery: (state) => {
      state.loansPaid.queryParams = initialState.loansPaid.queryParams;
    },
    clearPremiumInstallmentsUnPaidQuery: (state) => {
      state.premiumInstallmentsUnPaid.queryParams = initialState.premiumInstallmentsUnPaid.queryParams;
    },
    clearLoansUnPaidQuery: (state) => {
      state.loansUnPaid.queryParams = initialState.loansUnPaid.queryParams;
    },
    setNextPagePremiumInstallmentsPaid: (state) => {
      if (state.premiumInstallmentsPaid.pagination.currentPage < state.premiumInstallmentsPaid.pagination.totalPage) {
        state.premiumInstallmentsPaid.pagination.currentPage = state.premiumInstallmentsPaid.pagination.currentPage + 1;
        state.premiumInstallmentsPaid.queryParams.pageNumber = state.premiumInstallmentsPaid.pagination.currentPage;
      }
    },
    setPervPagePremiumInstallmentsPaid: (state) => {
      if (state.premiumInstallmentsPaid.pagination.currentPage > 1) {
        state.premiumInstallmentsPaid.pagination.currentPage = state.premiumInstallmentsPaid.pagination.currentPage - 1;
        state.premiumInstallmentsPaid.queryParams.pageNumber = state.premiumInstallmentsPaid.pagination.currentPage;
      }
    },
    setFirstPagePremiumInstallmentsPaid: (state) => {
      state.premiumInstallmentsPaid.pagination.currentPage = 1;
      state.premiumInstallmentsPaid.queryParams.pageNumber = state.premiumInstallmentsPaid.pagination.currentPage;
    },
    setEndPagePremiumInstallmentsPaid: (state) => {
      state.premiumInstallmentsPaid.pagination.currentPage = state.premiumInstallmentsPaid.pagination.totalPage;
      state.premiumInstallmentsPaid.queryParams.pageNumber = state.premiumInstallmentsPaid.pagination.currentPage;
    },
    setCurrentPagePremiumInstallmentsPaid: (state, action) => {
      state.premiumInstallmentsPaid.pagination.currentPage = action.payload;
      state.premiumInstallmentsPaid.queryParams.pageNumber = state.premiumInstallmentsPaid.pagination.currentPage;
    },
    setCustomPageSizePremiumInstallmentsPaid: (state, action) => {
      state.premiumInstallmentsPaid.pagination.customPageSize = action.payload;
      state.premiumInstallmentsPaid.queryParams.pageSize = state.premiumInstallmentsPaid.pagination.customPageSize;
    },
    setFirstItemNumberPremiumInstallmentsPaid: (state, action) => {
      state.premiumInstallmentsPaid.pagination.firstItemNumber = action.payload;
    },
    setLastItemNumberPremiumInstallmentsPaid: (state, action) => {
      state.premiumInstallmentsPaid.pagination.lastItemNumber = action.payload;
    },

    setTotalPagePremiumInstallmentsUnPaid: (state, action) => {
      state.premiumInstallmentsUnPaid.pagination.totalPage = action.payload;
    },
    clearPremiumInstallmentsUnPaid: (state) => {
      state.premiumInstallmentsUnPaid.data = undefined;
    },
    setNextPagePremiumInstallmentsUnPaid: (state) => {
      if (
        state.premiumInstallmentsUnPaid.pagination.currentPage < state.premiumInstallmentsUnPaid.pagination.totalPage
      ) {
        state.premiumInstallmentsUnPaid.pagination.currentPage =
          state.premiumInstallmentsUnPaid.pagination.currentPage + 1;
        state.premiumInstallmentsUnPaid.queryParams.pageNumber = state.premiumInstallmentsUnPaid.pagination.currentPage;
      }
    },
    setPervPagePremiumInstallmentsUnPaid: (state) => {
      if (state.premiumInstallmentsUnPaid.pagination.currentPage > 1) {
        state.premiumInstallmentsUnPaid.pagination.currentPage =
          state.premiumInstallmentsUnPaid.pagination.currentPage - 1;
        state.premiumInstallmentsUnPaid.queryParams.pageNumber = state.premiumInstallmentsUnPaid.pagination.currentPage;
      }
    },
    setFirstPagePremiumInstallmentsUnPaid: (state) => {
      state.premiumInstallmentsUnPaid.pagination.currentPage = 1;
      state.premiumInstallmentsUnPaid.queryParams.pageNumber = state.premiumInstallmentsUnPaid.pagination.currentPage;
    },
    setEndPagePremiumInstallmentsUnPaid: (state) => {
      state.premiumInstallmentsUnPaid.pagination.currentPage = state.premiumInstallmentsUnPaid.pagination.totalPage;
      state.premiumInstallmentsUnPaid.queryParams.pageNumber = state.premiumInstallmentsUnPaid.pagination.currentPage;
    },
    setCurrentPagePremiumInstallmentsUnPaid: (state, action) => {
      state.premiumInstallmentsUnPaid.pagination.currentPage = action.payload;
      state.premiumInstallmentsUnPaid.queryParams.pageNumber = state.premiumInstallmentsUnPaid.pagination.currentPage;
    },
    setCustomPageSizePremiumInstallmentsUnPaid: (state, action) => {
      state.premiumInstallmentsUnPaid.pagination.customPageSize = action.payload;
      state.premiumInstallmentsUnPaid.queryParams.pageSize = state.premiumInstallmentsUnPaid.pagination.customPageSize;
    },
    setFirstItemNumberPremiumInstallmentsUnPaid: (state, action) => {
      state.premiumInstallmentsUnPaid.pagination.firstItemNumber = action.payload;
    },
    setLastItemNumberPremiumInstallmentsUnPaid: (state, action) => {
      state.premiumInstallmentsUnPaid.pagination.lastItemNumber = action.payload;
    },

    setTotalPageLoansPaid: (state, action) => {
      state.loansPaid.pagination.totalPage = action.payload;
    },
    clearLoansPaid: (state) => {
      state.loansPaid.data = undefined;
    },
    setNextPageLoansPaid: (state) => {
      if (state.loansPaid.pagination.currentPage < state.loansPaid.pagination.totalPage) {
        state.loansPaid.pagination.currentPage = state.loansPaid.pagination.currentPage + 1;
        state.loansPaid.queryParams.pageNumber = state.loansPaid.pagination.currentPage;
      }
    },
    setPervPageLoansPaid: (state) => {
      if (state.loansPaid.pagination.currentPage > 1) {
        state.loansPaid.pagination.currentPage = state.loansPaid.pagination.currentPage - 1;
        state.loansPaid.queryParams.pageNumber = state.loansPaid.pagination.currentPage;
      }
    },
    setFirstPageLoansPaid: (state) => {
      state.loansPaid.pagination.currentPage = 1;
      state.loansPaid.queryParams.pageNumber = state.loansPaid.pagination.currentPage;
    },
    setEndPageLoansPaid: (state) => {
      state.loansPaid.pagination.currentPage = state.loansPaid.pagination.totalPage;
      state.loansPaid.queryParams.pageNumber = state.loansPaid.pagination.currentPage;
    },
    setCurrentPageLoansPaid: (state, action) => {
      state.loansPaid.pagination.currentPage = action.payload;
      state.loansPaid.queryParams.pageNumber = state.loansPaid.pagination.currentPage;
    },
    setCustomPageSizeLoansPaid: (state, action) => {
      state.loansPaid.pagination.customPageSize = action.payload;
      state.loansPaid.queryParams.pageSize = state.loansPaid.pagination.customPageSize;
    },
    setFirstItemNumberLoansPaid: (state, action) => {
      state.loansPaid.pagination.firstItemNumber = action.payload;
    },
    setLastItemNumberLoansPaid: (state, action) => {
      state.loansPaid.pagination.lastItemNumber = action.payload;
    },

    setTotalPageLoansUnPaid: (state, action) => {
      state.loansUnPaid.pagination.totalPage = action.payload;
    },
    clearLoansUnPaid: (state) => {
      state.loansUnPaid.data = undefined;
    },
    setNextPageLoansUnPaid: (state) => {
      if (state.loansUnPaid.pagination.currentPage < state.loansUnPaid.pagination.totalPage) {
        state.loansUnPaid.pagination.currentPage = state.loansUnPaid.pagination.currentPage + 1;
        state.loansUnPaid.queryParams.pageNumber = state.loansUnPaid.pagination.currentPage;
      }
    },
    setPervPageLoansUnPaid: (state) => {
      if (state.loansUnPaid.pagination.currentPage > 1) {
        state.loansUnPaid.pagination.currentPage = state.loansUnPaid.pagination.currentPage - 1;
        state.loansUnPaid.queryParams.pageNumber = state.loansUnPaid.pagination.currentPage;
      }
    },
    setFirstPageLoansUnPaid: (state) => {
      state.loansUnPaid.pagination.currentPage = 1;
      state.loansUnPaid.queryParams.pageNumber = state.loansUnPaid.pagination.currentPage;
    },
    setEndPageLoansUnPaid: (state) => {
      state.loansUnPaid.pagination.currentPage = state.loansUnPaid.pagination.totalPage;
      state.loansUnPaid.queryParams.pageNumber = state.loansUnPaid.pagination.currentPage;
    },
    setCurrentPageLoansUnPaid: (state, action) => {
      state.loansUnPaid.pagination.currentPage = action.payload;
      state.loansUnPaid.queryParams.pageNumber = state.loansUnPaid.pagination.currentPage;
    },
    setCustomPageSizeLoansUnPaid: (state, action) => {
      state.loansUnPaid.pagination.customPageSize = action.payload;
      state.loansUnPaid.queryParams.pageSize = state.loansUnPaid.pagination.customPageSize;
    },
    setFirstItemNumberLoansUnPaid: (state, action) => {
      state.loansUnPaid.pagination.firstItemNumber = action.payload;
    },
    setLastItemNumberLoansUnPaid: (state, action) => {
      state.loansUnPaid.pagination.lastItemNumber = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInsurancePolicyInfoDetail.pending, (state) => {
        state.insurancePolicyInfoDetail.loading = true;
      })
      .addCase(getInsurancePolicyInfoDetail.fulfilled, (state, action) => {
        state.insurancePolicyInfoDetail.data = action.payload;
        state.insurancePolicyInfoDetail.loading = false;
      })
      .addCase(getInsurancePolicyInfoDetail.rejected, (state) => {
        state.insurancePolicyInfoDetail.loading = false;
      });
    builder
      .addCase(getAllPremiumInstallmentPaidPagedFilter.pending, (state) => {
        state.premiumInstallmentsPaid.loading = true;
      })
      .addCase(getAllPremiumInstallmentPaidPagedFilter.fulfilled, (state, action) => {
        state.premiumInstallmentsPaid.data = action.payload;
        state.premiumInstallmentsPaid.loading = false;
      })
      .addCase(getAllPremiumInstallmentPaidPagedFilter.rejected, (state) => {
        state.premiumInstallmentsPaid.loading = false;
      });
    builder
      .addCase(getAllPremiumInstallmentUnPaidPagedFilter.pending, (state) => {
        state.premiumInstallmentsUnPaid.loading = true;
      })
      .addCase(getAllPremiumInstallmentUnPaidPagedFilter.fulfilled, (state, action) => {
        state.premiumInstallmentsUnPaid.data = action.payload;
        state.premiumInstallmentsUnPaid.loading = false;
      })
      .addCase(getAllPremiumInstallmentUnPaidPagedFilter.rejected, (state) => {
        state.premiumInstallmentsUnPaid.loading = false;
      });

    builder
      .addCase(getAllLoanPaidPagedFilter.pending, (state) => {
        state.loansPaid.loading = true;
      })
      .addCase(getAllLoanPaidPagedFilter.fulfilled, (state, action) => {
        state.loansPaid.data = action.payload;
        state.loansPaid.loading = false;
      })
      .addCase(getAllLoanPaidPagedFilter.rejected, (state) => {
        state.loansPaid.loading = false;
      });
    builder
      .addCase(getActiveLoan.pending, (state) => {
        state.activeLoan.loading = true;
      })
      .addCase(getActiveLoan.fulfilled, (state, action) => {
        state.activeLoan.data = action.payload;
        state.activeLoan.loading = false;
      })
      .addCase(getActiveLoan.rejected, (state) => {
        state.activeLoan.loading = false;
      });

    builder
      .addCase(getPayPremiumInstallmentConfig.pending, (state) => {
        state.payPremiumInstallmentConfig.loading = true;
      })
      .addCase(getPayPremiumInstallmentConfig.fulfilled, (state, action) => {
        state.payPremiumInstallmentConfig.loading = false;
        if (action.payload !== undefined) {
          state.payPremiumInstallmentConfig.data = action.payload;
        }
        return state;
      })
      .addCase(getPayPremiumInstallmentConfig.rejected, (state) => {
        state.payPremiumInstallmentConfig.loading = false;
      });

    builder
      .addCase(getAllLoanUnPaidPagedFilter.pending, (state) => {
        state.loansUnPaid.loading = true;
      })
      .addCase(getAllLoanUnPaidPagedFilter.fulfilled, (state, action) => {
        state.loansUnPaid.data = action.payload;
        state.loansUnPaid.loading = false;
      })
      .addCase(getAllLoanUnPaidPagedFilter.rejected, (state) => {
        state.loansUnPaid.loading = false;
      });
    builder
      .addCase(createPremiumInstallment.pending, (state) => {
        state.premiumInstallment.loading = true;
      })
      .addCase(createPremiumInstallment.fulfilled, (state) => {
        state.premiumInstallment.loading = false;
      })
      .addCase(createPremiumInstallment.rejected, (state) => {
        state.premiumInstallment.loading = false;
      });
    builder
      .addCase(createLoan.pending, (state) => {
        state.loan.loading = true;
      })
      .addCase(createLoan.fulfilled, (state) => {
        state.loan.loading = false;
      })
      .addCase(createLoan.rejected, (state) => {
        state.loan.loading = false;
      });
    builder
      .addCase(wepodPayOrder.pending, (state) => {
        state.payOrder.loading = true;
      })
      .addCase(wepodPayOrder.fulfilled, (state) => {
        state.payOrder.loading = false;
      })
      .addCase(wepodPayOrder.rejected, (state) => {
        state.payOrder.loading = false;
      });
  },
});

export const {
  setStepOneModel,
  setStepTwoModel,
  informationAndPayWizardNextStep,
  informationAndPayWizardPreviousStep,
  clearStepOneModel,
  resetWizard,
  setInformationAndPayBimehNamehInitialState,
  informationAndPayDetailWizard,
  setInsurancePolicyInfo,
  informationAndPayWizardPayInstallmentStep,
  informationAndPayWizardPremiumInstallmentsPaidStep,
  informationAndPayWizardPremiumInstallmentsUnPaidStep,
  informationAndPayWizardLoansPaidStep,
  informationAndPayWizardLoansUnPaidStep,
  informationAndPayBimehNamehHaStep,

  setTotalPagePremiumInstallmentsPaid,
  setNextPagePremiumInstallmentsPaid,
  setPervPagePremiumInstallmentsPaid,
  setFirstPagePremiumInstallmentsPaid,
  setEndPagePremiumInstallmentsPaid,
  setCurrentPagePremiumInstallmentsPaid,
  setCustomPageSizePremiumInstallmentsPaid,
  setFirstItemNumberPremiumInstallmentsPaid,
  setLastItemNumberPremiumInstallmentsPaid,

  setTotalPageLoansPaid,
  setNextPageLoansPaid,
  setPervPageLoansPaid,
  setFirstPageLoansPaid,
  setEndPageLoansPaid,
  setCurrentPageLoansPaid,
  setCustomPageSizeLoansPaid,
  setFirstItemNumberLoansPaid,
  setLastItemNumberLoansPaid,
  clearLoansPaid,
  clearLoansUnPaid,
  clearPremiumInstallmentsPaid,
  clearPremiumInstallmentsUnPaid,
  clearLoansPaidQuery,
  clearPremiumInstallmentsPaidQuery,
  clearLoansUnPaidQuery,
  clearPremiumInstallmentsUnPaidQuery,
  setTotalPageLoansUnPaid,
  setNextPageLoansUnPaid,
  setPervPageLoansUnPaid,
  setFirstPageLoansUnPaid,
  setEndPageLoansUnPaid,
  setCurrentPageLoansUnPaid,
  setCustomPageSizeLoansUnPaid,
  setFirstItemNumberLoansUnPaid,
  setLastItemNumberLoansUnPaid,

  setTotalPagePremiumInstallmentsUnPaid,
  setNextPagePremiumInstallmentsUnPaid,
  setPervPagePremiumInstallmentsUnPaid,
  setFirstPagePremiumInstallmentsUnPaid,
  setEndPagePremiumInstallmentsUnPaid,
  setCurrentPagePremiumInstallmentsUnPaid,
  setCustomPageSizePremiumInstallmentsUnPaid,
  setFirstItemNumberPremiumInstallmentsUnPaid,
  setLastItemNumberPremiumInstallmentsUnPaid,
} = lifeInformationAndPayReducer.actions;

export default lifeInformationAndPayReducer.reducer;
